import 'styles/global.css';
import { userTabSelectedState } from 'states';
import { useRecoilState } from 'recoil';

interface MainTabProps {
  tabItems: any[];
}

export const MainTab = ({ tabItems }: MainTabProps) => {
  const [, setUserTabSelected] = useRecoilState(userTabSelectedState);

  const selectUser = (n: number) => {
    if (n === 0) {
      setUserTabSelected(false);
    }
    if (n === 1) {
      setUserTabSelected(true);
    }
  };

  return (
    <>
      {tabItems.length > 0 && (
        <>
          <nav>
            <div className={`nav nav-tabs`} id="nav-tab" role="tablist">
              {tabItems.map((i: any, j: number) => {
                return (
                  <button
                    className={`nav-link ${j === 0 ? 'active' : ''}`}
                    id={i.tabId}
                    data-bs-toggle="tab"
                    data-bs-target={i.target}
                    type="button"
                    role="tab"
                    aria-controls={i.control}
                    aria-selected={`${j === 0 ? 'true' : 'false'}`}
                    key={i.tabId}
                    onClick={(e) => selectUser(j)}
                  >
                    {i.name}
                  </button>
                );
              })}
            </div>
          </nav>
          <div className="tab-content" id="nav-tabContent">
            {tabItems.map((m: any, n: number) => {
              return (
                <div
                  className={`${n === 0 ? 'tab-pane fade show active' : 'tab-pane fade'}`}
                  id={m.control}
                  role="tabpanel"
                  aria-labelledby={m.tabId}
                  key={m.tabId}
                >
                  {m.content}
                </div>
              );
            })}
          </div>
        </>
      )}
    </>
  );
};
